import React from 'react';
import { ManagedPopup } from 'js/components/common/Popup';
import { useCombinedOnClose } from 'js/components/common/PopupManager';
import { ReCaptcha } from 'js/components/main/ReCaptcha';
import { useTranslations } from 'js/hooks/i18n';

import * as Types from './types';

import style from './ReCaptchaPopup.scss';

const layerClassNames = {
    layout: style.layout
};

const popupClassNames = {
    inner: style.popupInner
};

export const ReCaptchaPopup: React.FC<Types.IReCaptchaPopupData> = ({
    id,
    title,
    onClose,
    operation,
    onReCaptchaTokenValidate,
    onReCaptchaTokenError
}) => {
    const closePopup = useCombinedOnClose(onClose, id);
    const translate = useTranslations('playtech.mobile.system.recaptcha.');

    return (
        <ManagedPopup
            id={id}
            title={title || translate('error.captchaNotPassed')}
            controls={false}
            onClose={closePopup}
            classNames={popupClassNames}
            layerClassNames={layerClassNames}
        >
            <div className={style.captcha}>
                <ReCaptcha
                    operation={operation}
                    onValidate={onReCaptchaTokenValidate}
                    onError={onReCaptchaTokenError}
                />
            </div>
        </ManagedPopup>
    );
};
